import { render, staticRenderFns } from "./stuErrorStat.vue?vue&type=template&id=6dedca1e"
import script from "./stuErrorStat.vue?vue&type=script&lang=js"
export * from "./stuErrorStat.vue?vue&type=script&lang=js"
import style0 from "./stuErrorStat.vue?vue&type=style&index=0&id=6dedca1e&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports